import {fromJS, Map} from 'immutable';

import * as actions from './actions';


export default function reducer(
    state = fromJS({
        elementId: window.uuidv4(),
        errors: {},
    }),
    action,
) {
    if (action.elementId === state.get('elementId')) {
        switch (action.type) {
        case actions.SET_ERRORS:
            state = state.set('errors', new Map(action.errors));
            break;
        }
    }
    return state;
}
